<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button class="float-right" @click="() => newUser()" >{{$t('transportUnits.newUnit')}}</b-button>
					<h2>{{$t('global.transportUnits')}}</h2>
					<hr>
					<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'transport-units-index-list') } ">
						<div class="row">
							<b-form-group class="col-md-2" :label="$t('global.search')">
								<b-form-input v-model="filters.search" type="text" />
							</b-form-group>
							<b-form-group class="col" label=".">
								<b-button type="submit" variant="primary">{{$t('global.search')}}</b-button>
							</b-form-group>
						</div>
					</b-form>
					<AjaxTable
						id="transport-units-index-list"
						:filters="filters"
						:columns="columns"
						resource="transport-units"
					>
						<template v-slot:cell(actions)="row">
							<div class="text-center">
								<b-button @click="(event) => modelView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="edit" />
								</b-button>
								<b-button @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
							</div>
						</template>
					</AjaxTable>
				</div>
			</div>
			<Single ref="single" :success-callback="successCallback" />
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'

export default {
		components: { MainLayout, Single, AjaxTable },
		data(){
				return {
					modalInfo : {
						modelId:-1,
					},
					filters : {
						search:'',
					},
					columns : [
						{key:'id',label:'ID'},
						{key:'name',label:this.$t('transportUnits.name')},
						{key:'plateNumber',label:this.$t('transportUnits.plateNumber')},
						{key:'unitBrand',label:this.$t('transportUnits.unitBrand')},
						{key:'unitModel',label:this.$t('transportUnits.unitModel')},
						{key:'unitModelYear',label:this.$t('transportUnits.unitModelYear')},
						{key:'maxPassengers',label:this.$t('transportUnits.maxPassengers')},
						{key:'status',label:this.$t('global.status')},
						{key:'actions',label:this.$t('global.actions')},
					],
				}
		},
		methods:{
			successCallback(){

				this.$root.$emit('bv::refresh::table', 'transport-units-index-list')
				this.$root.$emit('bv::refresh::table', 'drivers-index-list')
			},
			modelView(item){
				this.$refs['single'].loadModel(item.id)
			},
			newUser(accessType){
				this.$refs['single'].loadModel(-1)
				if (accessType) {
					this.$refs['single'].setAccessType(accessType)
				}
			},
			modelDelete(item){
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						this.$root.api.delete(`/transport-units/${item.id}`).then(() => {
							this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ["transportUnitsOpts"], forceRefresh: true});
							this.$root.showAlert(this.$t('global.registerDeleted'),{variant:'warning'})
							this.$root.$emit('bv::refresh::table', 'transport-units-index-list')
							close()
						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			}
		},
		mounted(){
		}
}
</script>

<style>

</style>
